"use client";
import React from "react";

export default function PopularUses({ data }) {
  // Function to bold "floor scrubber"
  const highlightFloorScrubber = (text) => {
    const regex = new RegExp("(floor scrubber)", "gi"); // 'gi' for case-insensitive matching
    return text.replace(regex, "<strong>$1</strong>"); // Wraps "floor scrubber" with <strong>
  };

  return (
    <section className="new-section">
      <div className="new-section-title">
        <span className="title">Popular Uses</span>
      </div>
      <div className="new-section-content-wrapper">
        {data.map((use, index) => (
          <div className="new-section-content" key={index}>
            <h2>{use.attributes.name}</h2>
            <div className="new-section-tags">
              {use.attributes.keywords.map((keyword) => (
                <span key={keyword.id} className="tag">
                  {keyword.tag}
                </span>
              ))}
            </div>
            <div className="description-section">
              {use.attributes.description.map((desc) => (
                <p
                  key={desc.id}
                  dangerouslySetInnerHTML={{
                    __html: highlightFloorScrubber(desc.paragraph),
                  }}
                ></p>
              ))}
            </div>
            <div className="benefits-section">
              <h4>Benefits</h4>
              {use.attributes.benefits.map((benefit) => (
                <ul key={benefit.id}>
                  <li className="heading">{benefit.heading}</li>
                  <li className="desc">{benefit.description}</li>
                </ul>
              ))}
            </div>

            <h4>Suitable For</h4>
            <div className="new-section-tags">
              {use.attributes.floor.map((keyword) => (
                <span key={keyword.id} className="tag">
                  {keyword.bullet}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
